t = require('views/internal/teacup-with-helpers')('board_copy_vis')

module.exports = ->
  t.format 'this-board-will-be-visdisplaytext', { visIconClass: t.mustacheVar('visIconClass'), visDisplayText: t.mustacheVar('visDisplayText') }
  t.text ' '
  t.a '.js-change-vis', { href: '#' }, ->
    t.format 'change'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_copy_vis.coffee